import { Tooltip } from 'portal-commons';
import { FunctionComponent } from 'react';
import { faTag } from '@fortawesome/pro-regular-svg-icons';
import { Grid, TextField, makeStyles } from '@material-ui/core';

import HeadingBlock from './HeadingBlock';

interface BrandSectionProps {
  brandName: string;
}

const useStyles = makeStyles({
  popup: {
    margin: '5px 0',
    fontSize: '12px',
    background: '#68737A',
  },
});

const BrandSection: FunctionComponent<BrandSectionProps> = ({ brandName }) => {
  const classes = useStyles();

  return (
    <Grid item xs={12} data-testid="campaignDetailsFormBrand">
      <div className="brand wrapper">
        <HeadingBlock icon={faTag} title="Brand" />
        <Grid container>
          <Grid item xs={6}>
            <div className="form-group-field">
              <Tooltip classes={{ tooltip: classes.popup }} title={brandName}>
                <TextField
                  data-testid="campaignDetailsFormBrandInput"
                  label="Brand DBA Name"
                  value={brandName}
                  id="brandId"
                  fullWidth={true}
                  inputProps={{
                    'aria-label': 'brandId',
                    style: { overflow: 'hidden', textOverflow: 'ellipsis' },
                  }}
                  disabled={true}
                />
              </Tooltip>
            </div>
          </Grid>
        </Grid>
      </div>
    </Grid>
  );
};

export default BrandSection;
